"use client";
import { useState } from "react";
import { Box, Grid } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import Form from "@/components/form";
import Image from "next/image";
export default function Contact() {
  const [showScheduler, setShowScheduler] = useState(false);
  const calendlyUrl = process.env.NEXT_PUBLIC_AFFORDABLE_CALENDLY_LINK || "";

  return (
    <>
      <div className="background">
        <Image
          src="/affordableBackground.webp"
          alt=""
          aria-hidden="true"
          className="background-media"
          fetchPriority="high"
          priority
          fill
          sizes="100vw"
          quality={60}
        />
        <Grid container className="flex-container">
          {" "}
          <Grid size={{ xs: 12, md: 12, lg: 5 }}>
            <div className="center-align">
              <Box className="affordable-contact-item green">
                <a
                  className="large-link-affordable"
                  href="mailto:contact@snapconstruction.com"
                  target="_blank"
                >
                  <EmailIcon />
                  <span className="affordable-contact-text">
                    <p className="large-link-affordable">
                      contact@snapconstruction.com
                    </p>
                  </span>
                </a>
              </Box>
            </div>
          </Grid>{" "}
          <Grid size={{ xs: 12, md: 12, lg: 2 }}></Grid>
          <Grid size={{ xs: 12, md: 12, lg: 5 }}>
            {" "}
            <div className="center-align">
              <Box className="affordable-contact-item green">
                <a className="large-link-affordable" href="tel:6515714848">
                  <PhoneInTalkIcon />

                  <span className="affordable-contact-text">
                    <p className="large-link-affordable">651-571-4848</p>
                  </span>
                </a>
              </Box>
            </div>
          </Grid>
          <Grid size={{ xs: 12, md: 12, lg: 5 }}>
            <div
              className="center-align"
              style={{
                minHeight: "40vh",
                padding: "2rem",
              }}
            >
              {showScheduler ? (
                <iframe
                  title="Schedule a consultation"
                  width="90%"
                  height="100%"
                  src={calendlyUrl}
                  loading="lazy"
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              ) : (
                <Box
                  sx={{
                    width: "90%",
                    minHeight: "40vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                    background: "url('/calendar.avif') no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundColor: "rgba(255,255,255,0.92)",

                    textAlign: "center",
                  }}
                >
                  <p className="subtext" style={{ margin: 0, color: "black" }}>
                    Open the booking calendar (hosted by Calendly). This may set
                    third-party cookies.
                  </p>
                  <button
                    type="button"
                    className="contactButton"
                    onClick={() => setShowScheduler(true)}
                  >
                    Open Booking Calendar
                  </button>
                </Box>
              )}
            </div>
          </Grid>{" "}
          <Grid size={{ xs: 12, md: 12, lg: 2 }}>
            <div className="or green">
              <p>OR</p>
            </div>
          </Grid>
          <Grid size={{ xs: 12, md: 12, lg: 5 }}>
            <div className="center-align">
              <div className="form">
                <Form />
              </div>
            </div>
          </Grid>{" "}
        </Grid>
      </div>
    </>
  );
}
